"use strict";
const React = require('react');
const Navigation_1 = require('./Navigation');
const styles = {
    screen: {
        height: '100%',
        position: 'relative',
    },
    screenContent: {
        display: 'flex',
        flexDirection: 'column',
        height: `calc(100vh - ${Navigation_1.style.appBar.height})`,
        margin: `${Navigation_1.style.appBar.height} 16px 0`,
    },
};
exports.Screen = (props) => React.createElement("div", {style: styles.screen}, props.children);
exports.ScreenContent = (props) => React.createElement("div", {style: Object.assign({}, styles.screenContent, props.style)}, props.children);



/** WEBPACK FOOTER **
 ** ./src/components/Screen.tsx
 **/